/* tslint:disable */
/* eslint-disable */
/**
 * Rever Returns Public API
 * Service for managing Rever returns
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const ModelsExchangeFlow = {
    ExchangeFlow_NO_EXCHANGE_FLOW: 0,
    ExchangeFlow_OPEN: 1,
    ExchangeFlow_ONE_ON_ONE: 2,
    ExchangeFlow_OPEN_WITH_GIFT_CARD: 3,
    ExchangeFlow_FULL: 4
};
/**
 *
 * @export
 * @enum {string}
 */
export const ModelsPickupRange = {
    PickupRange_NO_RANGE: 0,
    PickupRange_RANGE_8_TO_12: 1,
    PickupRange_RANGE_12_TO_16: 2,
    PickupRange_RANGE_16_TO_20: 3
};
/**
 *
 * @export
 * @enum {string}
 */
export const ModelsRefundAction = {
    RefundAction_NO_ACTION: 0,
    RefundAction_TO_EXCHANGE: 1,
    RefundAction_TO_RETURN: 2
};
/**
 *
 * @export
 * @enum {string}
 */
export const ModelsRefundPaymentMethod = {
    RefundPaymentMethod_NO_PAYMENT_METHOD: 0,
    RefundPaymentMethod_BANK_TRANSFER: 1,
    RefundPaymentMethod_ORIGINAL: 2,
    RefundPaymentMethod_PROMO_CODE: 3,
    RefundPaymentMethod_GIFT_CARD: 4,
    RefundPaymentMethod_MANUAL: 5
};
/**
 *
 * @export
 * @enum {string}
 */
export const ModelsRefundTiming = {
    RefundTiming_NO_TIMING: 0,
    RefundTiming_ON_START_RETURN_PROCESS: 1,
    RefundTiming_ON_ITEM_SENT: 2,
    RefundTiming_ON_ITEM_VERIFIED: 3
};
/**
 *
 * @export
 * @enum {string}
 */
export const ModelsReturnMethod = {
    ReturnMethod_NO_RETURN_METHOD: 0,
    ReturnMethod_HOME_PICK_UP: 1,
    ReturnMethod_DROP_OFF_POINT: 2,
    ReturnMethod_DELIVERY_PICKUP: 3,
    ReturnMethod_IN_STORE: 4
};
/**
 *
 * @export
 * @enum {string}
 */
export const ModelsReturnReason = {
    ReturnReason_NO_RETURN_REASON: 0,
    ReturnReason_WRONG_SIZE: 1,
    ReturnReason_WRONG_COLOR: 2,
    ReturnReason_NOT_AS_EXPECTED: 3,
    ReturnReason_DEFECTIVE: 4,
    ReturnReason_CHANGED_MY_MIND: 5,
    ReturnReason_WRONG_ITEM: 6,
    ReturnReason_WRONG_SIZE_TOO_SMALL: 7,
    ReturnReason_WRONG_SIZE_TOO_BIG: 8
};
/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves a list of countries
         * @summary Retrieves a list of countries
         * @param {string} ecommerceID E-commerce ID is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries: (ecommerceID, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('countries', 'ecommerceID', ecommerceID);
            const localVarPath = `/{ecommerceID}/countries`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a list of provinces given a Country Code
         * @summary Retrieves a list of provinces given a Country Code
         * @param {string} ecommerceID E-commerce ID is required
         * @param {string} countryCode country code is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinces: (ecommerceID, countryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('provinces', 'ecommerceID', ecommerceID);
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('provinces', 'countryCode', countryCode);
            const localVarPath = `/{ecommerceID}/countries/{countryCode}/provinces`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)))
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves a list of countries
         * @summary Retrieves a list of countries
         * @param {string} ecommerceID E-commerce ID is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(ecommerceID, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countries(ecommerceID, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LocationsApi.countries']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieves a list of provinces given a Country Code
         * @summary Retrieves a list of provinces given a Country Code
         * @param {string} ecommerceID E-commerce ID is required
         * @param {string} countryCode country code is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinces(ecommerceID, countryCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.provinces(ecommerceID, countryCode, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LocationsApi.provinces']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LocationsApiFp(configuration);
    return {
        /**
         * Retrieves a list of countries
         * @summary Retrieves a list of countries
         * @param {LocationsApiCountriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(requestParameters, options) {
            return localVarFp.countries(requestParameters.ecommerceID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of provinces given a Country Code
         * @summary Retrieves a list of provinces given a Country Code
         * @param {LocationsApiProvincesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinces(requestParameters, options) {
            return localVarFp.provinces(requestParameters.ecommerceID, requestParameters.countryCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * Retrieves a list of countries
     * @summary Retrieves a list of countries
     * @param {LocationsApiCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    countries(requestParameters, options) {
        return LocationsApiFp(this.configuration).countries(requestParameters.ecommerceID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a list of provinces given a Country Code
     * @summary Retrieves a list of provinces given a Country Code
     * @param {LocationsApiProvincesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    provinces(requestParameters, options) {
        return LocationsApiFp(this.configuration).provinces(requestParameters.ecommerceID, requestParameters.countryCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RefundMethodsApi - axios parameter creator
 * @export
 */
export const RefundMethodsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid RefundMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {PkgInfrastructureRestCalculateRefundMethodsRequest} calculateRefundMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundMethods: (ecommerceID, calculateRefundMethodsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('refundMethods', 'ecommerceID', ecommerceID);
            // verify required parameter 'calculateRefundMethodsRequest' is not null or undefined
            assertParamExists('refundMethods', 'calculateRefundMethodsRequest', calculateRefundMethodsRequest);
            const localVarPath = `/{ecommerceID}/refund_methods/calculate`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(calculateRefundMethodsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RefundMethodsApi - functional programming interface
 * @export
 */
export const RefundMethodsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RefundMethodsApiAxiosParamCreator(configuration);
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid RefundMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {PkgInfrastructureRestCalculateRefundMethodsRequest} calculateRefundMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundMethods(ecommerceID, calculateRefundMethodsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refundMethods(ecommerceID, calculateRefundMethodsRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['RefundMethodsApi.refundMethods']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * RefundMethodsApi - factory interface
 * @export
 */
export const RefundMethodsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RefundMethodsApiFp(configuration);
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid RefundMethods given the input
         * @param {RefundMethodsApiRefundMethodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundMethods(requestParameters, options) {
            return localVarFp.refundMethods(requestParameters.ecommerceID, requestParameters.calculateRefundMethodsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RefundMethodsApi - object-oriented interface
 * @export
 * @class RefundMethodsApi
 * @extends {BaseAPI}
 */
export class RefundMethodsApi extends BaseAPI {
    /**
     * retrieves a list of valid return methods
     * @summary Retrieves a list valid RefundMethods given the input
     * @param {RefundMethodsApiRefundMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundMethodsApi
     */
    refundMethods(requestParameters, options) {
        return RefundMethodsApiFp(this.configuration).refundMethods(requestParameters.ecommerceID, requestParameters.calculateRefundMethodsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReturnMethodsApi - axios parameter creator
 * @export
 */
export const ReturnMethodsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid ReturnMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {PkgInfrastructureRestGetReturnMethodsRequest} getReturnMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMethods: (ecommerceID, getReturnMethodsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('returnMethods', 'ecommerceID', ecommerceID);
            // verify required parameter 'getReturnMethodsRequest' is not null or undefined
            assertParamExists('returnMethods', 'getReturnMethodsRequest', getReturnMethodsRequest);
            const localVarPath = `/{ecommerceID}/get_return_methods`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getReturnMethodsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReturnMethodsApi - functional programming interface
 * @export
 */
export const ReturnMethodsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReturnMethodsApiAxiosParamCreator(configuration);
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid ReturnMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {PkgInfrastructureRestGetReturnMethodsRequest} getReturnMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMethods(ecommerceID, getReturnMethodsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnMethods(ecommerceID, getReturnMethodsRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReturnMethodsApi.returnMethods']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ReturnMethodsApi - factory interface
 * @export
 */
export const ReturnMethodsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReturnMethodsApiFp(configuration);
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid ReturnMethods given the input
         * @param {ReturnMethodsApiReturnMethodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMethods(requestParameters, options) {
            return localVarFp.returnMethods(requestParameters.ecommerceID, requestParameters.getReturnMethodsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReturnMethodsApi - object-oriented interface
 * @export
 * @class ReturnMethodsApi
 * @extends {BaseAPI}
 */
export class ReturnMethodsApi extends BaseAPI {
    /**
     * retrieves a list of valid return methods
     * @summary Retrieves a list valid ReturnMethods given the input
     * @param {ReturnMethodsApiReturnMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnMethodsApi
     */
    returnMethods(requestParameters, options) {
        return ReturnMethodsApiFp(this.configuration).returnMethods(requestParameters.ecommerceID, requestParameters.getReturnMethodsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReturnsApi - axios parameter creator
 * @export
 */
export const ReturnsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Method for calculating the line items and totals of a return process
         * @summary Calculating the amounts of a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ApiCalculateRequest} calculateData Calculate data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate: (ecommerceID, calculateData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('calculate', 'ecommerceID', ecommerceID);
            // verify required parameter 'calculateData' is not null or undefined
            assertParamExists('calculate', 'calculateData', calculateData);
            const localVarPath = `/{ecommerceID}/calculate`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(calculateData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Method for starting a return process given the return summary
         * @summary Start a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ApiProcessRequest} processData Return data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        process: (ecommerceID, processData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('process', 'ecommerceID', ecommerceID);
            // verify required parameter 'processData' is not null or undefined
            assertParamExists('process', 'processData', processData);
            const localVarPath = `/{ecommerceID}/process`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(processData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReturnsApi - functional programming interface
 * @export
 */
export const ReturnsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReturnsApiAxiosParamCreator(configuration);
    return {
        /**
         * Method for calculating the line items and totals of a return process
         * @summary Calculating the amounts of a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ApiCalculateRequest} calculateData Calculate data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate(ecommerceID, calculateData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.calculate(ecommerceID, calculateData, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReturnsApi.calculate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Method for starting a return process given the return summary
         * @summary Start a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ApiProcessRequest} processData Return data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        process(ecommerceID, processData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.process(ecommerceID, processData, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReturnsApi.process']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ReturnsApi - factory interface
 * @export
 */
export const ReturnsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReturnsApiFp(configuration);
    return {
        /**
         * Method for calculating the line items and totals of a return process
         * @summary Calculating the amounts of a return process
         * @param {ReturnsApiCalculateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate(requestParameters, options) {
            return localVarFp.calculate(requestParameters.ecommerceID, requestParameters.calculateData, options).then((request) => request(axios, basePath));
        },
        /**
         * Method for starting a return process given the return summary
         * @summary Start a return process
         * @param {ReturnsApiProcessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        process(requestParameters, options) {
            return localVarFp.process(requestParameters.ecommerceID, requestParameters.processData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReturnsApi - object-oriented interface
 * @export
 * @class ReturnsApi
 * @extends {BaseAPI}
 */
export class ReturnsApi extends BaseAPI {
    /**
     * Method for calculating the line items and totals of a return process
     * @summary Calculating the amounts of a return process
     * @param {ReturnsApiCalculateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    calculate(requestParameters, options) {
        return ReturnsApiFp(this.configuration).calculate(requestParameters.ecommerceID, requestParameters.calculateData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Method for starting a return process given the return summary
     * @summary Start a return process
     * @param {ReturnsApiProcessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    process(requestParameters, options) {
        return ReturnsApiFp(this.configuration).process(requestParameters.ecommerceID, requestParameters.processData, options).then((request) => request(this.axios, this.basePath));
    }
}
